export const matchAnyDomain = (email = '', domains = []) => (
  domains.filter((domain) => matchDomain(email, domain)).length > 0
);

export const matchDomain = (email = '', domain = '') => (
  email.split('@').pop() === domain
);
